<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="2"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                @click="serviceCustomerClickFun()"
                :style="{ color: '#1981ff' }"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center">
          <!-- //3-4个卡片选择，需要 自适应宽度 -->
          <div
            class="container_center_item"
            v-for="(item, index) in row.question_list"
            :key="index"
          >
            <div class="container_center_item_title">
              {{ item.title }}
            </div>
            <el-link
              type="primary"
              class="container_center_item_link"
              @click="
                $router.push({
                  path: '/coursecontent',
                  query: {
                    id: item.course_id,
                    course_cate_id: 9,
                  },
                })
              "
              >查看相关教材</el-link
            >
            <el-link
              type="primary"
              class="container_center_item_link"
              v-if="item.video.length>0"
              @click="seedemoFun(item.video)"
              >查看示范</el-link
            >
            <el-button
              type="primary"
              @click="selectQuestion(item)"
              round
              class="elbutton"
              >确定</el-button
            >
            <div
              class="container_center_item_content html-data"
              v-html="item.desc_html"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="示范视频" :visible.sync="dialogVideoVisible">
      <div class="video_wrap">
        <video
          v-if="dialogVideoVisible"
          ref="myVideo"
          preload="auto"
          :src="targetVideoSrc"
          controls="controls"
          class="video_class"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      targetVideoSrc: "",
      dialogVideoVisible: false,
      areaOptions: [],
      rules: {
        areas: [{ required: true, message: "请选择地区", trigger: "blur" }],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        num: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        grade: [{ required: true, message: "请选择等级", trigger: "blur" }],
      },
      formData: {
        areas: [],
      },
      gradeOptions: [
        {
          id: 1,
          name: "一级",
        },
        {
          id: 2,
          name: "二级",
        },
        {
          id: 3,
          name: "三级",
        },
        {
          id: 4,
          name: "四级",
        },
        {
          id: 5,
          name: "五级",
        },
        {
          id: 6,
          name: "六级",
        },
        {
          id: 7,
          name: "七级",
        },
        {
          id: 8,
          name: "八级",
        },
      ],
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
    };
  },
  components: {
    NewsListItem,
  },
  computed: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    this.fetch();
  },
  methods: {
    seedemoFun(tarvideo) {
      this.targetVideoSrc = "";
      this.dialogVideoVisible = true;
      if (tarvideo.length) {
        this.targetVideoSrc = tarvideo[0].url;
      }
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/step4Detail",
        {
          id: that.formData.id,
        },
        (res) => {
          that.formData = res.data;
          that.row = res.data;
        }
      );
    },
    selectQuestion(record) {
      const that = this;
      that.$api.post(
        "/api/kaoji/step4save",
        {
          id: that.row.id,
          shijian_question_id: record.id,
        },
        (r) => {
          that.$router.push({
            name: "KaojiApplyStep5",
            query: {
              id: that.row.id,
            },
          });
        }
      );
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped lang="scss">
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-right: 24px;
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1000px;
    /*min-height: 560px;*/
    // background: #ffffff;
    // box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    // border-radius: 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .container_center_item {
      flex: 1;
      /*min-height: 560px;*/
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 48px;
      border: 1px solid #ffffff;
      margin-right: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 93px 0 20px 0;
      box-sizing: border-box;
      &:last-child {
        margin-right: 0px;
      }
      .container_center_item_title {
        width: 219px;
        height: 51px;
        font-size: 18px;
        text-align: center;
        font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
          "\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 48px;
      }
      .container_center_item_link {
        margin-bottom: 7px;
      }
      .elbutton {
        width: 139px;
        height: 44px;
        margin: 40px 0 21px 0;
      }
      .container_center_item_content {
        margin: 0 8px;
        /*height: 154px;*/
        border-radius: 20px;
        background: #f2f7ff;
        font-size: 14px;

        font-weight: 400;
        color: #666666;
        box-sizing: border-box;
        padding: 16px 8px 18px 7px;
        p {
          line-height: 20px;
        }
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
.video_wrap {
  text-align: center;
  .video_class {
    width: 66.7%;
    object-fit: cover;
  }
}
</style>


// WEBPACK FOOTER //
// KaojiApplyStep4.vue?b88dbdd4